import type { Dispatch } from 'redux';
import { Feature, createActionFactory, ThunkDispatch } from '../../../../shared';
import { createExportUnifiedGroupTask } from '../../data/groups/exportGroupActions';

export const dismissExportUnifiedGroupDialogAction = createActionFactory<{}>(
    'DismissExportGroupDialogAction',
    Feature.UnifiedGroups
);

export const exportUnifiedGroupConfirmClickedAction = createActionFactory<{
    groupId: string;
    groupSmtp: string;
    hubPersonaId: string;
}>('ExportGroupConfirmClickedAction', Feature.UnifiedGroups);

export const exportUnifiedGroupConfirmClicked = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupSmtp: string,
    hubPersonaId: string
) => {
    dispatch(exportUnifiedGroupConfirmClickedAction({ groupId, groupSmtp, hubPersonaId }));
    createExportUnifiedGroupTask(dispatch, groupId, groupSmtp, hubPersonaId);
};

export const dismissExportUnifiedGroupDialog = (dispatch: Dispatch) => () => {
    dispatch(dismissExportUnifiedGroupDialogAction());
};
export type { UnifiedGroup } from '../../../../shared';
export type { Action } from '../../../../shared';
